<template>
  <div class="action-modal">
    <div class="action-modal__container">
      <h1
        class="large-headline"
        v-if="modalOptions.title"
        v-html="modalOptions.title"
      ></h1>

      <p v-if="modalOptions.text" v-html="modalOptions.text"></p>

      <ButtonBase @click="primaryBtnActions">
        {{ modalOptions.primaryBtnText || "Got it!" }}
      </ButtonBase>

      <ButtonBase
        v-if="modalOptions.secondaryBtnAction"
        @click="secondaryBtnActions"
      >
        {{ modalOptions.secondaryBtnText }}
      </ButtonBase>
    </div>
  </div>
</template>
<script setup>
import { onMounted } from "vue";
import gsap from "gsap";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";

const props = defineProps({
  modalOptions: {
    type: Object,
    required: false,
    default: () => ({
      title: "",
      text: "",
      primaryBtnText: "Got it!",
      secondaryBtnText: "",
      alignment: {}, // used in BaseModal
    }),
  },
});

const $emit = defineEmits(["onPrimaryButtonClick", "onSecondaryButtonClick"]);

const primaryBtnActions = () => {
  if (props.modalOptions.primaryBtnAction) {
    props.modalOptions.primaryBtnAction();
  }

  return $emit("onPrimaryButtonClick");
};

const secondaryBtnActions = () => {
  if (props.modalOptions.secondaryBtnAction) {
    props.modalOptions.secondaryBtnAction();
  }

  return $emit("onSecondaryButtonClick");
};

onMounted(() => {
  const successTl = gsap.timeline();
  successTl.fromTo(
    ".action-modal",
    {
      duration: 0.75,
      y: 30,
      opacity: 0,
    },
    {
      y: 0,
      opacity: 1,
      delay: 0.5,
      ease: "inOut.power3",
    }
  );
});
</script>
<style lang="scss" scoped>
.action-modal {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  opacity: 0;
  background: var(--modal-content-background);
  border-radius: $border-radius;

  &__container {
    width: 295px;
    height: 298px;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    h1,
    p {
      color: $black;
    }
  }
}
</style>
